import { MessageInstance } from 'antd/es/message/interface';
import { HookAPI } from 'antd/es/modal/useModal';
import { NotificationInstance } from 'antd/es/notification/interface';

export const GlobalVar = {
  notification: null as any as NotificationInstance,
  message: null as any as MessageInstance,
  modal: null as any as HookAPI,
};
